// Core
import { 
	useBreakpointValue
} from '@chakra-ui/react';

// Components
import Desktop from './Desktop';
import Responsive from './Responsive';

const Pagination = ({ meta, currentPage, onPageChange, isLoadingPage, setIsLoadingPage }) => {
	const isMobile = useBreakpointValue({ base: true, lg: false });

	return (
		<>
			{ !isMobile ? 
				<Desktop 
					meta={meta} 
					currentPage={currentPage} 
					onPageChange={onPageChange} 
					isLoadingPage={isLoadingPage} 
					setIsLoadingPage={setIsLoadingPage}
					/>
				: 
				<Responsive 
					meta={meta} 
					currentPage={currentPage} 
					onPageChange={onPageChange} 
					isLoadingPage={isLoadingPage} 
					setIsLoadingPage={setIsLoadingPage}
					/>
			}
		</>
	);
};

export default Pagination;